import { maskDate } from "./mask";

document.addEventListener("DOMContentLoaded", () => {
  const input = document.getElementById("newsletter-preferences__birth_date");
  if (!input) return;

  input.setAttribute("inputmode", "numeric");
  input.setAttribute("maxlength", "10");

  input.addEventListener("input", () => {
    // Only reformat while appending at the end; reformatting a mid-field edit would scramble it.
    if (input.selectionStart !== input.value.length) return;
    input.value = maskDate(input.value);
  });
});
